var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"version-list"},[_c('list',{attrs:{"fs":_vm.versionFields,"api":"versions","editLink":_vm.editLink,"addLink":_vm.addLink,"showAction":_vm.showAction,"title":"Versions"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }